import './fileUploader.less';

const FileUploader = function(input, ismulti){
    let _this = this;
    let listContainer = $('.filesInput__list');
    let skipMessage = $('.skip-message');
    let counterContainer = $('.files-counter');
    let list;
    let initial = 0;
    let filesArray = [];
    let allowedExtensions = [".jpg", ".jpeg", ".bmp", ".gif", ".png"];
    
    listContainer.empty();
    
    this.addListElem = elem => {
        filesArray.push(elem);
        listContainer.append('<p>' + elem.name + '</p>');
    }
    
    this.hasExtension = (name, exts) => new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$', "i").test(name);
    
    this.showSkipMessage = ()=> {
        skipMessage.fadeIn();
        setTimeout(()=>{
            skipMessage.fadeOut();
        },1000);
    }
    
    this.filterExtensions = list => {
        list.map( (elem,index) => {
            !_this.hasExtension(elem.name, allowedExtensions) ? list.splice(index) : null;
        });
    };
    
    this.returnFiles = () => {
        initial++;
    
        list =  Array.from(document.getElementById(input.attr('id')).files);
    
        _this.filterExtensions(list);
    
        list.map(elem => {
            if (initial > 1){
                let exists= 0;
            
                filesArray.map( file => {
                    file.name === elem.name ? exists++ : null;
                });
            
                if (!exists > 0) {
                    if (ismulti === true) {
                        _this.addListElem(elem);
                    }else {
                        filesArray = [...elem];
                        listContainer.empty().html('<p>' + elem.name + '</p>');
                    }
    
                   
    
                } else {
                    _this.showSkipMessage();
                }
              
            }else {
                if (ismulti === true){
                    _this.addListElem(elem)
                } else {
                    filesArray = [];
                    filesArray.push(elem);
                    listContainer.empty().html('<p>' + elem.name + '</p>');
                }
            
            }
            counterContainer.text(filesArray.length);
        });
    
    };
    
    input.change(function(){
        _this.returnFiles();
    });
    
    this.returnFiles();
    
    return filesArray;
};



export { FileUploader };


// WEBPACK FOOTER //
// ./js/core/Helpers/fileUploader/fileUploader.js